import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=4f488e2c&"
import script from "./reply.vue?vue&type=script&lang=ts&"
export * from "./reply.vue?vue&type=script&lang=ts&"
import style0 from "./reply.vue?vue&type=style&index=0&id=4f488e2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports